package org.hs_soft.runmynesto.pages.home.mvi


import kotlinx.coroutines.flow.MutableStateFlow
import kotlinx.coroutines.flow.StateFlow
import kotlinx.serialization.builtins.ListSerializer
import kotlinx.serialization.builtins.serializer
import kotlinx.serialization.json.Json
import org.hs_soft.runmynesto.data.api_datasource.RequestManager
import org.hs_soft.runmynesto.data.local_datasource.local_storage.getFromLocalStorage
import org.hs_soft.runmynesto.data.local_datasource.local_storage.saveToLocalStorage
import org.hs_soft.runmynesto.domain.model.general.WindowSizeModeEnum
import org.hs_soft.runmynesto.domain.model.general.WindowSizeModel
import org.hs_soft.runmynesto.domain.model.home.home.data_assistant_logs.DataAssistantLogsModel
import org.hs_soft.runmynesto.domain.model.home.options.CountriesEnum
import org.hs_soft.runmynesto.domain.model.home.options.LanguageEnum
import org.hs_soft.runmynesto.domain.model.home.product.SpeechRecognitionLanguageEnum
import org.hs_soft.runmynesto.domain.model.home.product.tabs.tab_product_general.chat_model.*
import org.hs_soft.runmynesto.domain.model.menu.MenuItemsEnum
import org.hs_soft.runmynesto.domain.requestHandler
import org.hs_soft.runmynesto.domain.usecase.home.*
import org.hs_soft.runmynesto.domain.usecase.options.operation.OptionDataUseCase
import org.hs_soft.runmynesto.domain.usecase.options.virtual_card.GetVirtualCardInfoUseCase
import org.hs_soft.runmynesto.domain.usecase.product.DeleteCacheUseCase
import org.hs_soft.runmynesto.domain.usecase.product.SaveCompanyProfileIdUseCase
import org.hs_soft.runmynesto.domain.usecase.product.tab_product_general.GetDataAssistantAnswerUseCase
import org.hs_soft.runmynesto.domain.usecase.product.tab_product_general.GetDataAssistantMessageHistoryUseCase
import org.hs_soft.runmynesto.domain.usecase.product.tab_product_general.SaveDataAssistantFavoriteMessagesUseCase
import org.hs_soft.runmynesto.domain.usecase.user.CheckOutDataUseCase
import org.hs_soft.runmynesto.domain.util.*
import org.hs_soft.runmynesto.domain.util.helper.BaseViewModel

class HomeViewModel(
    private val requestManager: RequestManager,
    private val tokenProvider: TokenProvider,
    private val fetchIdTokenUseCase: FetchIdTokenUseCase,
    private val checkOutDataUseCase: CheckOutDataUseCase,
    private val saveCheckOutUseCase: SaveCheckOutUseCase,
    private val signOutUseCase:SignOutUseCase,
    private val userProfileDataUseCase: UserProfileDataUseCase,
    private val hsSoftAppsUseCase: HSSoftAppsUseCase,
    private val shopListUseCase: ShopListUseCase,
    private val optionsDataUseCase: OptionDataUseCase,
    private val saveCompanyProfileIdUseCase:SaveCompanyProfileIdUseCase,
    private val deleteCacheUseCase: DeleteCacheUseCase,
    private val saveLanguageUseCase: SaveLanguageUseCase,
    private val setNewCustomerUseCase:SetNewCustomerUseCase,
    private val getDataAssistantAnswerUseCase: GetDataAssistantAnswerUseCase,
    private val getDataAssistantMessageHistoryUseCase: GetDataAssistantMessageHistoryUseCase,
    private val getVirtualCardInfoUseCase: GetVirtualCardInfoUseCase,
    private val saveDataAssistantFavoriteMessagesUseCase: SaveDataAssistantFavoriteMessagesUseCase,
    private val globalSearchUseCase: GlobalSearchUseCase,
):BaseViewModel()
{

    private val _state = MutableStateFlow(HomeState())
    val state: StateFlow<HomeState> = _state

    override fun clear() {
        requestManager.cancelAll()
    }



     fun onEvent(event: HomeEvent) {
        when (event) {

            is HomeEvent.SearchGlobally->{
                searchGlobally(
                    searchValue=event.searchValue
                )
            }

            is HomeEvent.SetTabsClickableStatus->{
                setTabsClickableStatus(event.status)
            }

            is HomeEvent.DeleteCache->{
                deleteCache()
            }
            is HomeEvent.GetOptionData ->{
                getOptionData()
            }

            is HomeEvent.DismissAllDialogs->{
                dismissAllDialogs()
            }


            is HomeEvent.GetHSSoftApps->{
                getHSSoftApps()
            }

            is HomeEvent.SignOut->{
                signOut()
            }
            is HomeEvent.OnToolbarApplicationsMenuIconClick->{
                onToolbarApplicationsMenuIconClick()
            }
            is HomeEvent.UserProfileInfo->{
                getUserProfileInfo()
            }
            is HomeEvent.OnToolbarSettingIconClick->onToolbarSettingIconClick()
            is HomeEvent.ChangeShowingSearchBarInMobileStatus->changeShowingSearchBarInMobileStatus()
            is HomeEvent.GetCheckoutData->getAndSaveCheckoutData()
            is HomeEvent.FetchIdToken->fetchUserIdToken( )
            is HomeEvent.ChangeMenuStatus ->changeMenuStatus()
            is HomeEvent.CloseMenu ->closeMenu()
            is HomeEvent.InitWindowsSize ->initWindowSize(event.windowsSize)
            is HomeEvent.OnChangeName -> changeName(event.value)
            is HomeEvent.OnMenuItemClick->onMenuItemClick(menuItem = event.menuItem)
            is HomeEvent.GetShopList->getShopList()

            is HomeEvent.SetDataAssistantDialogStatus->{
                _state.value=_state.value.copy(
                    showDataAssistantDialog = event.status,
                    showDataAssistantIcon = !event.status
                )

                val lenientJson = Json {
                    ignoreUnknownKeys = true
                }

                if (!event.status) {
                    saveDataAssistantFavoriteMessages(
                        email = event.email,
                        favoriteMessages = lenientJson.decodeFromString<List<String>>(
                            getFromLocalStorage(IdUtils.favoriteMessages) ?: "")
                    )
                }
            }

            is HomeEvent.SetUserFavoriteMessagesStatus->{
                _state.value=_state.value.copy(
                    userFavoriteMessagesVisible = event.status
                )
            }

            is HomeEvent.SetInfoStatus->{
                _state.value=_state.value.copy(
                    userInfoVisible = event.status
                )
            }

            is HomeEvent.SetMoreStatus->{
                _state.value=_state.value.copy(
                    moreMenuVisible = event.status
                )
            }

            is HomeEvent.SetInputBarStatus->{
                _state.value=_state.value.copy(
                    inputBarVisible = event.status
                )
            }

            is HomeEvent.SetDataAssistantIconStatus->{
                _state.value=_state.value.copy(
                    showDataAssistantIcon = event.status
                )
            }

            is HomeEvent.GenerateDataAssistantAnswer->{
                generateDataAssistantAnswer(
                    companyID = event.email,
                    question=event.question,
                    messageHistory = event.messageHistory,
                    logLanguage = event.logLanguage,
                    userName = event.userName,
                    userEmail = event.userEmail,
                    userCompanyName = event.userCompanyName
                )
            }

            is HomeEvent.GetDataAssistantMessageHistory->{
                getDataAssistantMessageHistory(
                    companyID = event.email
                )
            }

            is HomeEvent.GetVirtualCardInfo->{
                getVirtualCardInfo()
            }

            is HomeEvent.OnChangeAIDataAssistantQuestion->{
                _state.value=_state.value
                    .copy(answerAIGeneratorQuestion = event.value)
            }

            is HomeEvent.SaveDataAssistantFavoriteMessages->{
                _state.value=_state.value
                    .copy(messageHistory = ChatMessageHistoryModel(
                        chatMessageHistory = event.messageHistory.chatMessageHistory,
                        favoriteMessages = event.favoriteMessages.toMutableList()
                    ))
                saveToLocalStorage(IdUtils.favoriteMessages, Json.encodeToString(ListSerializer(String.serializer()), event.favoriteMessages))
            }

        }
    }

    private fun searchGlobally(searchValue: String) {
        launch {
            requestHandler(
                loadingState = { isLoading ->
                    _state.value = _state.value.copy(loadingProgress = isLoading)
                },
                callRequest = {
                    globalSearchUseCase(searchValue = searchValue)
                },
                onSuccess = { result ->
                    _state.value = _state.value.copy(
                        globalSearchList = result.data?.cashAssist?.globalSearch
                    )
                },
            )
        }
    }



    private fun getVirtualCardInfo() {
        if (state.value.virtualCardInfo == null) {
            launch {
                requestHandler(
                    loadingState = { isLoading ->
                        _state.value = _state.value.copy(loadingProgress = isLoading)
                    },
                    callRequest = {
                        getVirtualCardInfoUseCase()
                    },
                    onSuccess = { result ->
                        _state.value = _state.value.copy(
                            virtualCardInfo = result.data?.cashAssist?.getVirtualCardConfig
                        )
                    },
                )
            }
        }
    }

    private fun getDataAssistantMessageHistory(companyID: String) {
        val lenientJson = Json {
            ignoreUnknownKeys = true
        }
        launch {
            requestHandler(
                loadingState = { isLoading ->
                    _state.value = _state.value.copy(
                        isDataAssistantDatabaseLoading = isLoading,
                        sendQuestionButtonIsClickable = !isLoading
                    )
                },
                callRequest = {
                    val userTimezoneOffsetMinutes = js("new Date().getTimezoneOffset()") as Int
                    val messages = lenientJson.decodeFromString<ChatMessageHistoryModel>(
                        getDataAssistantMessageHistoryUseCase(ApiUtils.DATA_ASSISTANT.name, companyID, userTimezoneOffsetMinutes)
                    )
                    val favoriteMessagesCached = lenientJson.decodeFromString<List<String>>(
                        getFromLocalStorage(IdUtils.favoriteMessages) ?: "[]"
                    )

                    if (messages.favoriteMessages != favoriteMessagesCached) {
                        messages.favoriteMessages = favoriteMessagesCached.toMutableList()
                        saveDataAssistantFavoriteMessagesUseCase(
                            ApiUtils.DATA_ASSISTANT.name,
                            companyID,
                            favoriteMessagesCached
                        )
                    }

                    messages
                },
                onSuccess = { messages ->
                    _state.value = _state.value.copy(
                        messageHistory = messages,
                        freeCredits = messages.freeTokens,
                        premiumCredits = messages.premiumTokens
                    )
                },
                onException = { e ->
                    _state.value = _state.value.copy(
                        isDataAssistantDatabaseLoading = false,
                        sendQuestionButtonIsClickable = true
                    )
                }
            )
        }
    }

    private fun saveDataAssistantFavoriteMessages(
        email: String,
        favoriteMessages: List<String>
    ) {
        launch {
            requestHandler(
                loadingState = { isLoading ->
                    _state.value = _state.value.copy(isDataAssistantDatabaseLoading = isLoading)
                },
                callRequest = {
                    saveDataAssistantFavoriteMessagesUseCase(
                        ApiUtils.DATA_ASSISTANT.name,
                        email,
                        favoriteMessages
                    )
                },
                onSuccess = { result ->

                },
                onException = { e ->
                    _state.value = _state.value.copy(
                        sendQuestionButtonIsClickable = true
                    )
                }
            )
        }
    }

    private fun generateDataAssistantAnswer(
        companyID: String,
        question: String,
        messageHistory: ChatMessageHistoryModel,
        logLanguage:String?,
        userName:String,
        userEmail:String,
        userCompanyName:String
    ) {
        val lenientJson = Json {
            ignoreUnknownKeys = true
        }
        messageHistory.chatMessageHistory.add(
            ChatSingleMessageModel(
                RoleMessageEnum.USER.role,
                ChatContentModel(text = question, files = mutableListOf())
            )
        )

        _state.value = _state.value.copy(
            messageHistory = messageHistory,
            answerAIGeneratorQuestion = ""
        )

        launch {
            requestHandler(
                loadingState = { isLoading ->
                    _state.value = _state.value.copy(
                        isDataAssistantAIGeneratorLoading = isLoading,
                        sendQuestionButtonIsClickable = !isLoading
                    )
                },
                callRequest = {
                    val userTimezoneOffsetMinutes = js("new Date().getTimezoneOffset()") as Int
                    getDataAssistantAnswerUseCase(
                        assistant = ApiUtils.DATA_ASSISTANT.name,
                        email = companyID,
                        question = question,
                        userTimezoneOffsetMinutes = userTimezoneOffsetMinutes,
                        userIdToken = tokenProvider.token,
                        cashList = state.value.cashList,
                        onLogAnswerUpdate = { logs ->
                            _state.value = _state.value.copy(
                                dataAssistantRequestLogs = logs ?: DataAssistantLogsModel(
                                    message = "",
                                    answer = "",
                                    isGenerating = false,
                                    audioUrl = null
                                )
                            )
                        },
                        language=logLanguage,
                        userName=userName,
                        userEmail=userEmail,
                        userCompanyName=userCompanyName
                    )
                },
                onSuccess = { dataAssistantAnswer ->
                    val dataAssistantChatSingleAnswer = lenientJson.decodeFromString<ChatSingleMessageModel>(dataAssistantAnswer)
                    messageHistory.chatMessageHistory.add(
                        ChatSingleMessageModel(
                            role = dataAssistantChatSingleAnswer.role,
                            content = ChatContentModel(
                                text = dataAssistantChatSingleAnswer.content.text,
                                files = dataAssistantChatSingleAnswer.content.files,
                                expertMode = dataAssistantChatSingleAnswer.content.expertMode
                            )
                        )
                    )

                    _state.value = _state.value.copy(
                        messageHistory = messageHistory,
                        freeCredits = dataAssistantChatSingleAnswer.freeTokens,
                        premiumCredits = dataAssistantChatSingleAnswer.premiumTokens,
                        dataAssistantRequestLogs = DataAssistantLogsModel(
                            message = null,
                            answer = null,
                            isGenerating = false,
                            audioUrl = null
                        )
                    )
                },
                onException = { e ->
                    _state.value = _state.value.copy(
                        isDataAssistantAIGeneratorLoading = false,
                        sendQuestionButtonIsClickable = true,
                        dataAssistantRequestLogs = DataAssistantLogsModel(
                            message = null,
                            answer = null,
                            isGenerating = null,
                            audioUrl = null
                        )
                    )
                }
            )
        }
    }

    private fun setTabsClickableStatus(status: Boolean) {
        _state.value = _state.value.copy(
            areTabsClickable = status
        )
    }

    private fun deleteCache() {
        launch {
            requestHandler(
                callRequest = {
                    deleteCacheUseCase()
                },
                onSuccess = { },
            )
        }
    }

    private fun getOptionData() {
        launch {
            requestHandler(
                callRequest = {
                    optionsDataUseCase()
                },
                onSuccess = { result ->
                    val config = result.data?.cashAssist?.getAppConfig

                    saveCompanyProfileIdUseCase(
                        id = config?.countryId ?: CountriesEnum.SWITZERLAND.id
                    )
                    launch {
                        saveLanguageUseCase(
                            lang = config?.language ?: LanguageEnum.German.displayName
                        )

                    }

                    val isNewCustomer = config?.name?.isEmpty() ?: true
                    launch {
                        setNewCustomerUseCase(newCustomer = isNewCustomer)
                    }


                    _state.value = _state.value.copy(
                        isNewCustomer = isNewCustomer,
                        speechLanguage = when(config?.language ?: LanguageEnum.German.displayName) {
                            LanguageEnum.German.displayName -> SpeechRecognitionLanguageEnum.German.speechLanguageName
                            LanguageEnum.English.displayName -> SpeechRecognitionLanguageEnum.English.speechLanguageName
                            LanguageEnum.French.displayName -> SpeechRecognitionLanguageEnum.French.speechLanguageName
                            LanguageEnum.Italian.displayName -> SpeechRecognitionLanguageEnum.Italian.speechLanguageName
                            LanguageEnum.Polish.displayName -> SpeechRecognitionLanguageEnum.Polish.speechLanguageName
                            LanguageEnum.Russian.displayName -> SpeechRecognitionLanguageEnum.Russian.speechLanguageName
                            LanguageEnum.Portuguese.displayName -> SpeechRecognitionLanguageEnum.Portuguese.speechLanguageName
                            else -> SpeechRecognitionLanguageEnum.German.speechLanguageName
                        },
                        logLanguage = config?.language ?: LanguageEnum.German.displayName
                    )

                    if (isNewCustomer) {
                        _state.value = _state.value.copy(
                            activePage = MenuItemsEnum.OPTIONS,
                            areTabsClickable = false
                        )
                    } else {
                        _state.value = _state.value.copy(
                            areTabsClickable = true
                        )
                    }
                },
            )
        }
    }

    private fun dismissAllDialogs() {
        _state.value = _state.value.copy(
            showSettingDialog = false,
            showApplications = false,
        )
    }

    private fun getShopList() {
        launch {
            requestHandler(
                loadingState = { isLoading ->
                    _state.value = _state.value.copy(isLoading = isLoading)
                },
                callRequest = {
                    shopListUseCase()
                },
                onSuccess = { result ->

                },
            )
        }
    }

    private fun onMenuItemClick(menuItem: MenuItemsEnum) {
        if (state.value.activePage == menuItem) {
            _state.value = _state.value.copy(isMenuExpandedHorizontally = false)
        } else if (state.value.areTabsClickable) {
            _state.value = _state.value.copy(
                activePage = menuItem,
                isMenuExpandedHorizontally = false
            )
        }
    }

    private fun getHSSoftApps() {
        launch {
            requestHandler(
                loadingState = { isLoading ->
                    _state.value = _state.value.copy(isLoading = isLoading)
                },
                callRequest = {
                    hsSoftAppsUseCase()
                },
                onSuccess = { result ->
                    _state.value = _state.value.copy(
                        listOfHSSortsApps = result.data?.listHSWebApps
                    )
                },
            )
        }
    }

    private fun getUserProfileInfo() {
        launch {
            requestHandler(
                loadingState = { isLoading ->
                    _state.value = _state.value.copy(isLoading = isLoading)
                },
                callRequest = {
                    userProfileDataUseCase()
                },
                onSuccess = { result ->
                    val profileData = result.data?.userProfileData
                    _state.value = _state.value.copy(
                        profileInfo = profileData,
                        selectedLanguage = profileData?.user?.locale ?: LanguageEnum.English.value
                    )
                    saveLanguage(profileData?.user?.locale ?: LanguageEnum.English.value)
                },
            )
        }
    }

    private fun saveLanguage(lang: String) {
        launch {
            requestHandler(
                callRequest = {
                    saveLanguageUseCase(lang = lang)
                },
                onSuccess = {},
            )
        }
    }

    private fun signOut() {
        launch {
            requestHandler(
                loadingState = { isLoading ->
                    _state.value = _state.value.copy(isLoading = isLoading)
                },
                callRequest = {
                    var success = false
                    signOutUseCase(
                        onSuccess = {
                            success = true
                        },
                        onError = {

                        }
                    )
                    success
                },
                onSuccess = { success ->
                    if (success) {
                        _state.value = _state.value.copy(showSettingDialog = false)
                    }
                },
            )
        }
    }

    private fun onToolbarApplicationsMenuIconClick() {
        _state.value = _state.value.copy(
            showApplications = !state.value.showApplications,
            showSettingDialog = false
        )
    }

    private fun onToolbarSettingIconClick() {
        _state.value = _state.value.copy(
            showSettingDialog = !state.value.showSettingDialog,
            showApplications = false
        )
    }

    private fun changeShowingSearchBarInMobileStatus() {
        _state.value = _state.value.copy(
            showSearchBarInMobileMode = !state.value.showSearchBarInMobileMode
        )
    }

    private fun getAndSaveCheckoutData() {
        launch {
            requestHandler(
                loadingState = { isLoading ->
                    _state.value = _state.value.copy(isLoading = isLoading)
                },
                callRequest = {
                    checkOutDataUseCase()
                },
                onSuccess = { result ->
                    launch {
                        saveCheckOutUseCase(model = result)
                        _state.value = _state.value.copy(
                            cashList = result.data.cashAssist?.children
                        )
                    }

                },
            )
        }
    }

    private fun updateToken(newToken: String) {
        tokenProvider.updateToken(newToken)
    }

    private fun fetchUserIdToken() {
        launch {
            requestHandler(
                loadingState = { isLoading ->
                    _state.value = _state.value.copy(isLoading = isLoading)
                },
                callRequest = {
                    fetchIdTokenUseCase()
                },
                onSuccess = { idToken ->
                    _state.value = _state.value.copy(idToken = idToken)
                    updateToken(idToken)
                },
                onException = { e ->
                    _state.value = _state.value.copy(
                        errorInfo = e.message.toString()
                    )
                }
            )
        }
    }

    private fun closeMenu() {
        _state.value = _state.value.copy(isMenuExpandedHorizontally = false)
    }

    private fun changeMenuStatus() {
        _state.value = _state.value.copy(
            isMenuExpandedHorizontally = !state.value.isMenuExpandedHorizontally
        )
    }

    private fun initWindowSize(windowsSize: WindowSizeModel) {
        if (windowsSize.width > Constants.Responsive.MaxTabletWidth) {
            _state.value = _state.value.copy(
                windowSizeMode = WindowSizeModeEnum.Desktop
            )
        } else if (windowsSize.width < Constants.Responsive.MaxTabletWidth
            && windowsSize.width > Constants.Responsive.MaxPhoneWidth
        ) {
            _state.value = _state.value.copy(
                windowSizeMode = WindowSizeModeEnum.TABLET
            )
        } else {
            _state.value = _state.value.copy(
                windowSizeMode = WindowSizeModeEnum.PHONE
            )
        }
    }

    private fun changeName(value: String) {
        _state.value = _state.value.copy(username = value)
    }





}